import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/chatme`;

export default {
  getTokenAndDomain() {
    return Client.post(`${resource}/user/login`);
  },
  getRoomInfo(payload) {
    return Client.get(`${resource}/user/get-room`, {
      params: payload,
    });
  },
  getRoomInfoById(roomId) {
    return Client.get(`${resource}/get-room/${roomId}`);
  },
  searchRoom(payload) {
    return Client.get(`${resource}/user/search-room`, {
      params: payload,
    });
  },
  getRequestJoin() {
    return Client.get(`${resource}/user/request-join`);
  },
  joinRoom(payload) {
    return Client.post(`${resource}/user/join-room`, payload);
  },
  leaveRoom(payload) {
    return Client.post(`${resource}/user/leave-room`, payload);
  },
  transferRoom(payload) {
    return Client.post(`${resource}/user/transfer-room`, payload);
  },
};
